import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTeamTypingUsers } from "../../../context/TeamTypingContext";
import { buildTypingLabel } from "../utils/teamTypingLabels";

const TeamSpaceListSubtitle = ({ spaceId, lastMessagePreview = "" }) => {
  const { t } = useTranslation("team");
  const typingUsers = useTeamTypingUsers(spaceId);
  const typingLabel = typingUsers.length ? buildTypingLabel(typingUsers, t) : "";
  const text = typingLabel || lastMessagePreview;

  if (!text) return null;

  return (
    <Typography
      variant="caption"
      color={typingLabel ? "primary.main" : "text.secondary"}
      noWrap
      display="block"
      sx={{ fontStyle: typingLabel ? "italic" : "normal", lineHeight: 1.35 }}
    >
      {text}
    </Typography>
  );
};

export default TeamSpaceListSubtitle;
